export const OPEN_SCAN_TO_BATCH_MODAL = 'OPEN_SCAN_TO_BATCH_MODAL';
export const openScanToBatchModal = () => ({
  type: OPEN_SCAN_TO_BATCH_MODAL,
});

export const SCAN_TO_BATCH_FULFILLMENT_PLAN_SEARCH = 'SCAN_TO_BATCH_FULFILLMENT_PLAN_SEARCH';
export const scanToBatchFulfillmentPlanSearch = (searchString) => ({
  type: SCAN_TO_BATCH_FULFILLMENT_PLAN_SEARCH,
  searchString,
});

export const ADD_FULFILLMENT_PLANS_TO_BATCH = 'ADD_FULFILLMENT_PLANS_TO_BATCH';
export const addFulfillmentPlansToBatch = (fulfillmentPlanIds) => ({
  type: ADD_FULFILLMENT_PLANS_TO_BATCH,
  fulfillmentPlanIds,
});

export const SCANNED_ORDER_IS_IN_ANOTHER_BATCH = 'SCANNED_ORDER_IS_IN_ANOTHER_BATCH';
export const scannedOrderIsInAnotherBatch = (fulfillmentPlanIds, fulfillmentPlanSetId) => ({
  type: SCANNED_ORDER_IS_IN_ANOTHER_BATCH,
  fulfillmentPlanIds,
  fulfillmentPlanSetId,
});

export const SCANNED_ORDER_IS_NOT_FOUND = 'SCANNED_ORDER_IS_NOT_FOUND';
export const orderNotFound = () => ({
  type: SCANNED_ORDER_IS_NOT_FOUND,
});

export const UNABLE_TO_MOVE_ORDER_TO_BATCH = 'UNABLE_TO_MOVE_ORDER_TO_BATCH';
export const unableToMoveOrderToBatch = () => ({
  type: UNABLE_TO_MOVE_ORDER_TO_BATCH,
});
